import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ClipLoader } from "react-spinners";
import { db } from '../firebaseConfig'; 
import { collection, getDocs, query, limit, where } from 'firebase/firestore'; 
import './Destinations.css';

const Destinations = () => {
  const [destinations, setDestinations] = useState([]);
  const [popularSpots, setPopularSpots] = useState([]); 
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        // 1. FETCH COUNTRIES
        const colRef = collection(db, 'countries');
        const countrySnapshot = await getDocs(colRef);
        
        const countryList = countrySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        
        setDestinations(countryList);

        // 2. FETCH POPULAR SPOTS (Curated Logic)
        const spotsPromises = countryList.map(async (country) => {
            
            // --- EXCLUDE SOUTH AFRICA ---
            if (country.name === 'South Africa') return null;

            const spotsRef = collection(db, 'countries', country.id, 'touristSpots');
            let q;

            // --- KENYA LOGIC (Get Maasai Mara) ---
            if (country.name === 'Kenya') {
                q = query(spotsRef, where("name", "==", "Maasai Mara"));
            } 
            // --- UGANDA LOGIC (Get Murchison Falls) ---
            else if (country.name === 'Uganda') {
                q = query(spotsRef, where("name", "==", "Murchison Falls"));
            }
            // --- ZANZIBAR / TANZANIA LOGIC (Get Prison Island) ---
            // Checking both names just in case you stored it under Tanzania
            else if (country.name === 'Zanzibar' || country.name === 'Tanzania') {
                q = query(spotsRef, where("name", "==", "Prison Island"));
            }
            else {
                // --- OTHERS (Get 1st available spot) ---
                q = query(spotsRef, limit(1));
            }

            const spotSnapshot = await getDocs(q);

            // --- FALLBACK LOGIC ---
            // If specific spot (Maasai Mara/Murchison/Prison Island) is NOT found,
            // just grab the first available spot so the card isn't empty.
            if (spotSnapshot.empty && (country.name === 'Kenya' || country.name === 'Uganda' || country.name === 'Zanzibar' || country.name === 'Tanzania')) {
                 const fallbackQ = query(spotsRef, limit(1));
                 const fallbackSnap = await getDocs(fallbackQ);
                 if (!fallbackSnap.empty) {
                     const doc = fallbackSnap.docs[0];
                     return { id: doc.id, ...doc.data(), countryName: country.name };
                 }
            }

            if (!spotSnapshot.empty) {
                const doc = spotSnapshot.docs[0];
                return {
                    id: doc.id,
                    ...doc.data(),
                    countryName: country.name 
                };
            }
            return null;
        });

        const results = await Promise.all(spotsPromises);
        // Clean up nulls and limit to 4 (or remove slice if you want all of them)
        const mixedSpots = results.filter(spot => spot !== null).slice(0, 4); 
        
        setPopularSpots(mixedSpots);

      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <div style={{ textAlign: 'center', marginTop: '20px' }}>
      <h2>Tour Destinations</h2>
      
      {/* COUNTRIES GRID */}
      <div className="grid-container">
        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', padding: '50px' }}>
            <ClipLoader color={"#333"} loading={loading} size={100} />
          </div>
        ) : destinations.length > 0 ? (
          destinations.map((destination) => (
            <Link key={destination.id} to={`/destinations/${destination.name}`} className="grid-item-link">
              <div className="grid-card" style={{ backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${destination.image})` }}>
                <span>{destination.name}</span>
                <button className="view-button">View</button>
              </div>
            </Link>
          ))
        ) : (
          <p>No results found</p>
        )}
      </div>

      {/* POPULAR SPOTS GRID */}
      <h2 style={{ marginTop: '40px' }}>Popular Tourist Destination Spots</h2>
      <div className="grid-container">
        {loading && <p>Loading popular spots...</p>}
        {!loading && popularSpots.length === 0 && <p>No popular spots found.</p>}

        {popularSpots.map((spot, index) => (
             <Link 
                key={index} 
                to={`/destinations/${spot.countryName}/${spot.name}`} 
                className="grid-item-link"
             >
                <div className="grid-card popular-card">
                  {/* Image sits at the back */}
                  <img 
                    src={spot.image} 
                    alt={spot.name} 
                    className="popular-card-img"
                    onError={(e) => {e.target.src='https://via.placeholder.com/400x200?text=No+Image'}}
                  />
                  
                  {/* Overlay sits on top of the image */}
                  <div className="popular-card-overlay">
                      <h4>{spot.name}</h4>
                      <p className="description">
                          {spot.popularity 
                            ? (spot.popularity.length > 200 ? spot.popularity.substring(0, 200) + '...' : spot.popularity)
                            : (spot.message ? spot.message.substring(0, 200) + '...' : 'Explore this amazing destination.')}
                      </p>
                      <p className="location">
                          {spot.location}
                      </p>
                  </div>
                </div>
            </Link>
        ))}
      </div>
    </div>
  );
};

export default Destinations;